import { BASE_FILTERS, MAX_PRICE } from "./brand";

/* "Vor Ort" covers every non-online way an offer can take place. */
export const ON_SITE_TYPES = ["on_site", "home", "by_arrangement"];
export const ONLINE_TYPES = ["online"];

export const initialFilters = () => ({ ...BASE_FILTERS });

/*
 * Builds the filter payload for searchCourses.
 *
 * The BASE_FILTERS baseline (baby age group, bookable only) always wins, so the
 * reduced filter UI can never widen the search beyond what this page is for.
 * An empty locationTypes becomes null: searchCourses strips nil values, so the
 * request simply carries no location restriction instead of one that matches
 * nothing.
 */
export const buildSearchFilters = (filters = {}) => {
  const locationTypes = filters.locationTypes || [];

  return {
    ...filters,
    ...BASE_FILTERS,
    locationTypes: locationTypes.length > 0 ? locationTypes : null,
    maxPrice: filters.maxPrice >= MAX_PRICE ? null : filters.maxPrice || null,
  };
};

export const isLocationTypeActive = (locationTypes = [], group) =>
  group.every(type => (locationTypes || []).includes(type));

/* Adds or removes a whole group at once, so "Vor Ort" toggles its three
 * underlying types together rather than leaving a partial selection. */
export const toggleLocationType = (locationTypes = [], group) => {
  const current = locationTypes || [];

  if (isLocationTypeActive(current, group)) {
    return current.filter(type => !group.includes(type));
  }

  return [...current.filter(type => !group.includes(type)), ...group];
};
